module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "be-wrapper"
  }, [_vm._c('navbar'), _vm._v(" "), _vm._c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a16abe7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Auth.vue
// module id = 619
// module chunks = 1